import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import {
  MMAPlacementCard,
  PlacementHeadline,
  PlacementDescription,
} from '../../shared-components';

import searchIcon from '../media/search.svg';
import batteryIcon from '../media/battery.svg';
import wifiIcon from '../media/wifi.svg';

const MiniSpotlight = ({
  placementData, // UAPVMSingleImagePlacement
  isEnabled,
  finalUrl,
  longHeadline,
  description,
  i18n,
  classes,
}) => {
  const {
    placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
  } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};
  if (!placementData || !imageMeta) {
    return null;
  }

  // const srcForCroppedImageView = showImage && this.props.image.FinalSrc;
  const imagePreviewWidth = previewHeight * aspectRatio;

  const cropping = expandedPlacementCropping || placementCropping;

  return (
    <MMAPlacementCard url={finalUrl} width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard}>
      <div className={classnames(classes.placementImageContainer)}>
        {
          imageMeta.url &&
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
          />
        }
      </div>
      <div className="hardcode-time" >
        <div className="time" >{i18n.getString(_TL_('10:36'))}</div>
        <div className="date" >{i18n.getString(_TL_('Tuesday, October 18'))}</div>
      </div>
      <div className={classnames(classes.placementTextContainer)}>
        <div className={classes.placementTopRightSection}>
          <img className={classes.placementSearchIconTopRight} alt="" src={searchIcon} />
          <PlacementHeadline
            headlineText={longHeadline}
            placementHeadlineClassName={classnames(classes.placementLongHeadline, 'long-headline')}
          />
          <PlacementDescription
            description={description}
            placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
          />
        </div>
      </div>
      <img className={classes.placementWifiIcon} alt="" src={wifiIcon} />
      <img className={classes.placementBatteryIcon} alt="" src={batteryIcon} />
    </MMAPlacementCard>
  );
};

MiniSpotlight.propTypes = {
  placementData: PropTypes.shape({}).isRequired, // UAPVMSingleImagePlacement
  isEnabled: PropTypes.bool,
  longHeadline: PropTypes.string,
  finalUrl: PropTypes.string,
  description: PropTypes.string,
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({
    placementTextContainer: PropTypes.string,
    placementTopRightSection: PropTypes.string,
    placementImageContainer: PropTypes.string,
    placementCard: PropTypes.string,
    placementLongHeadline: PropTypes.string,
    placementDescription: PropTypes.string,
    placementSearchIconTopRight: PropTypes.string,
    placementWifiIcon: PropTypes.string,
    placementBatteryIcon: PropTypes.string,
  }).isRequired,
};

MiniSpotlight.defaultProps = {
  isEnabled: true,
  longHeadline: undefined,
  finalUrl: undefined,
  description: undefined,
};

export const UnstyledMiniSpotlight = MiniSpotlight;
